import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { RestAPIsService } from './rest-apis.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UiMessage, UiMessageTypes } from '../models/ui-messages.interface';

@Injectable({
  providedIn: 'root'
})

export class UIMessagesService {

  private uiMessages:any;  //todo: need to replace the type
  constructor(private restAPI: RestAPIsService) { }

  getUIMessages(): Observable<any> {
    return this.restAPI.getAPI(`carbon/v3/ui-messages`, 'domestic').pipe(
      map((response : any) => {
        if (response.code == 200 && response.data) {
            this.setUIMessages(response.data);
        }
        return response;
      })  
    );
  }

  setUIMessages(messages: UiMessageTypes) {
    this.uiMessages = messages;
  }

  getPopupUIMessageByKey(key: string) {
    return this.uiMessages ? this.uiMessages['POPUP'][key] || null : null;
  }

  getUIMessageByKey(key: string) {
    return this.uiMessages ? this.uiMessages[key] || null : null;
  }

}
